var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QuesBankform',{attrs:{"bId":_vm.bId,"isSystem":_vm.isSystem,"bankType":_vm.bankType}})}
var staticRenderFns = []

export { render, staticRenderFns }